export default class BillingType {
    constructor(id, name, active, billable)
    {
        this.id = id;
        this.name = name;
        this.active = active;
        this.billable = billable;
    }

    static fromRPC(data)
    {
        return new BillingType(
                data["id"],
                data["name"],
                data["active"],
                data["billable"]
        );
    }
}


// WEBPACK FOOTER //
// ./web/js/store/BillingType.js